import { VisaInlinePreview } from './VisaInlinePreview';
import { VisaBulkDownload } from './VisaBulkDownload';
import { useEffect, useState } from 'react';
import { api, type Me, type VisaDocumentKind, type VisaDocumentList } from './api';
import { VIZE_BELGELERI as M } from './metin/vize-belgeleri';
import { tarihSaatBae } from './web-sitesi-bicim';
import './visa-documents.css';

const REQUIRED: VisaDocumentKind[] = ['PASSPORT', 'BIOMETRIC', 'HOTEL_BOOKING', 'FLIGHT_TICKET'];
export function VisaDocuments(props: { requestId: string; applicantName: string; me: Me }) {
  return <VisaDocumentsContent key={props.requestId} {...props} />;
}
function VisaDocumentsContent({ requestId, applicantName, me }: { requestId: string; applicantName: string; me: Me }) {
  const allowed = me.permissions.includes('workflow:read') && me.permissions.includes('document:read');
  const [preview, setPreview] = useState<{ requestId: string; id: string; kind: VisaDocumentKind } | null>(null);
  const [result, setResult] = useState<VisaDocumentList | null>(null);
  const [failed, setFailed] = useState(false);
  const [retry, setRetry] = useState(0);
  const [downloading, setDownloading] = useState<string | null>(null);
  const [downloadFailed, setDownloadFailed] = useState(false);
  useEffect(() => {
    let active = true;
    setPreview(null); setResult(null); setFailed(false); setDownloadFailed(false); setDownloading(null);
    if (allowed) void api.visaDocuments(requestId).then(data => { if (active) setResult(data); }).catch(() => { if (active) setFailed(true); });
    return () => { active = false; };
  }, [requestId, allowed, retry]);
  const download = async (id: string) => {
    setDownloading(id); setDownloadFailed(false);
    try { await api.downloadVisaDocument(requestId, id); } catch { setDownloadFailed(true); } finally { setDownloading(null); }
  };
  const outputs = (['VISA_PDF', 'INSURANCE_POLICY'] as VisaDocumentKind[]).filter(kind => result?.documents.some(document => document.kind === kind && document.uploaded));
  const card = (kind: VisaDocumentKind) => {
    const document = result?.documents.find(item => item.kind === kind);
    const uploadedAt = document?.uploadedAt && Number.isFinite(Date.parse(document.uploadedAt)) ? document.uploadedAt : null;
    return <li key={kind} data-testid={`visa-document-${kind}`}>
      <h6>{M.turler[kind]}</h6>
      <p>{document?.uploaded === true ? M.yuklendi : document?.uploaded === false ? M.eksik : M.bilinmiyor}</p>
      {document?.uploaded ? <>
        <p>{uploadedAt ? `${M.tarih}: ${tarihSaatBae(uploadedAt)}` : M.tarihYok}</p>
        {document.id ? <div className="visa-document-actions">
          <button type="button" onClick={() => setPreview({ requestId, id: document.id!, kind })}>{M.onizle}</button>
          <button type="button" disabled={downloading !== null} onClick={() => void download(document.id!)}>{downloading === document.id ? M.indiriliyor : M.indir}</button>
        </div> : <p>{M.indirmeYok}</p>}
        {allowed && preview?.requestId === requestId && preview.id === document.id ? <VisaInlinePreview key={`${requestId}:${preview.id}`} requestId={requestId} documentId={preview.id} kind={kind} close={() => setPreview(null)} /> : null}
      </> : null}
    </li>;
  };
  return <section className="visa-documents" data-testid="visa-documents">
    <h5>{M.baslik}</h5>
    {!allowed ? <p>{M.yetki}</p> : null}
    {allowed && failed ? <div role="alert"><p>{M.hata}</p><button type="button" onClick={() => setRetry(value => value + 1)}>{M.yeniden}</button></div> : null}
    {allowed && !failed && !result ? <p role="status">{M.yukleniyor}</p> : null}
    {allowed && !failed && result ? <>
      <VisaBulkDownload key={requestId} requestId={requestId} applicantName={applicantName} documents={result.documents} />
      <h6>{M.musteriBelgeleri}</h6><ul>{REQUIRED.map(card)}</ul>
      {outputs.length > 0 ? <><h6>{M.hazirlananBelgeler}</h6><ul>{outputs.map(card)}</ul></> : null}
    </> : null}
    {downloadFailed ? <p role="alert">{M.indirmeHatasi}</p> : null}
  </section>;
}
